export function formatCount(value) {
  return value ? value : 0
}

export function formatText(value) {
  return value === 1 ? 'Patient' : 'Patients'
}
